<div class="warning-banner">
  <sn-icon [fontSet]="'fas'" [fontIcon]="'fa-warning'"></sn-icon>
  <span>This core is oversubscribed. Adjust camera settings to resolve this issue.</span>
</div>
